import {
  SideMenuItems,
} from "../../Helpers/Enums";
import SideBarMenu from "../../Components/SideBarMenu";
import PatientDetails from "../../Components/PatientInformation";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import { AppContext } from "../../Contexts/AppContextProvider";
import React, { useContext, useEffect } from "react";
import {
  applySidebarState,
  toggleSidebar,
} from "../../Helpers/Utilities";


const AbbreviationList = () => {
  const navigatePaths = {
    prevPage: "",
    currPage: "/AbbreviationList",
    nextPage: "/PatientScreening",
  };

  const {
    isSideMenuActive,
    setisSideMenuActive,
  } = useContext(AppContext);


  const SaveForm = async () => {
   return true;
  }; 

  useEffect(() => {
    applySidebarState(isSideMenuActive);
  }, [isSideMenuActive]);

  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SaveForm} />
          </div>
        </div>
      </section>

      <section className="main-survey-section main-survey-button">
        <div>
          <SideBarMenu activePageId={SideMenuItems.AbbreviationList} />
          <>
            <button
              className={isSideMenuActive ? "openbtn" : "openbtn active"}
              onClick={() =>
                toggleSidebar(isSideMenuActive, setisSideMenuActive)
              }
            >
              <i
                id="arrowNavigation"
                className="fa fa-arrow-left"
                aria-hidden="true"
              ></i>
            </button>
          </>
          <div className="col-pad-left" id="main">
            <div className="survey-section-content" id="contentsec">
              <div className="survey-section-content-header" >
                <h4>** ABBREVIATION LIST</h4>
              </div>

              <div className="survey-introduction-section">
                <div className="survey-introduction-content survey-content-box">
                  <div className="instructions">
                    <div>
                      The following abbreviations are used in the following
                      forms. Please reference the table below as you complete
                      the medical record abstraction process.{" "}
                    </div>
                  </div>

                  <div className="abbreviation-container">
                    <table className="abbreviation-table">
                      <thead>
                        <th className="abbreviation-td">Abbreviation</th>
                        <th className="abbreviation-td">Definition</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="abbreviation-td">2-MC</td>
                          <td className="abbreviation-td">2-methylcitrate</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">3-HP</td>
                          <td className="abbreviation-td">3-hydroxypropionate</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">ADHD</td>
                          <td className="abbreviation-td">attention deficit hyperactive disorder</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">C2</td>
                          <td className="abbreviation-td">acyl-carnitine</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">C3</td>
                          <td className="abbreviation-td">propionyl-carnitine</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">cbl</td>
                          <td className="abbreviation-td">Cobalamin-related</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">CKD</td>
                          <td className="abbreviation-td">chronic kidney disease</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">CMV</td>
                          <td className="abbreviation-td">Cytomegalovirus</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">CSF</td>
                          <td className="abbreviation-td">cerebrospinal fluid</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">DQ</td>
                          <td className="abbreviation-td">developmental quotient</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">EBV</td>
                          <td className="abbreviation-td">Epstein–Barr virus</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">eGFR</td>
                          <td className="abbreviation-td">
                            estimated glomerular filtration rate
                          </td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">ER</td>
                          <td className="abbreviation-td">emergency room</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">ESRD</td>
                          <td className="abbreviation-td">end stage renal disease</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">FGF21</td>
                          <td className="abbreviation-td">
                            fibroblast growth factor 21
                          </td>
                        </tr>
                        
                        <tr>
                          <td className="abbreviation-td">HGVS</td>
                          <td className="abbreviation-td">
                            Human Genome Variation Society
                          </td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">ICU</td>
                          <td className="abbreviation-td">intensive care unit</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">IP</td>
                          <td className="abbreviation-td">inpatient</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">IQ</td>
                          <td className="abbreviation-td">intellectual quotient</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">IV</td>
                          <td className="abbreviation-td">intravenous</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">LT</td>
                          <td className="abbreviation-td">liver transplant</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">LKT</td>
                          <td className="abbreviation-td">
                            liver and kidney transplant
                          </td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">MDE</td>
                          <td className="abbreviation-td">
                            metabolic decompensation event
                          </td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">MMA</td>
                          <td className="abbreviation-td">methylmalonic acidemia</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td"><i>mut</i></td>
                          <td className="abbreviation-td">methlymalonyl-CoA mutase</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">NICU</td>
                          <td className="abbreviation-td">
                            neonate intensive care unit
                          </td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">OP</td>
                          <td className="abbreviation-td">outpatient/ambulatory</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">OR</td>
                          <td className="abbreviation-td">operating room</td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">PaCO<sub>2</sub></td>
                          <td className="abbreviation-td">
                            partial pressure of carbon dioxide
                          </td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">PRES</td>
                          <td className="abbreviation-td">
                            posterior reversible encephalopathy syndrome
                          </td>
                        </tr>
                        <tr>
                          <td className="abbreviation-td">US</td>
                          <td className="abbreviation-td">United States</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="survey-section-content-foot">
                <SaveAndNavigate paths={navigatePaths} Save={SaveForm} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AbbreviationList;
